//TODO - this is a dup of SFRA main.js. Customize file per DCI
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./login/headerLogin'));
    processInclude(require('./components/tieredPrices'));
    processInclude(require('./product/productPopUp'));
    processInclude(require('./components/tracking'));
    processInclude(require('./utilities/lazyLoad'));
    processInclude(require('./addressBook/addressBook'));
});

require('./thirdParty/bootstrap');
require('base/components/spinner');
